import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SwUpdate } from '@angular/service-worker';
import { interval } from 'rxjs';

@Injectable()
export class PwaUpdateService {
  constructor(private swUpdate: SwUpdate, private snackbar: MatSnackBar) {
    if (!this.swUpdate.isEnabled) {
      console.warn('service worker not enabled');
      return;
    }

    this.checkForUpdates();
    this.swUpdate.available.subscribe((evt) => {
      console.log('new update received from server');
      const snack = this.snackbar.open('Actualización Disponible', 'Recargar', {
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      snack.onAction().subscribe(() => {
        window.location.reload();
      });
    });
  }

  private checkForUpdates() {
    console.log('checking for updates activated');
    interval(1 * 60 * 1000).subscribe(() => {
      console.log('- checking for updates now');
      this.swUpdate.checkForUpdate();
    });
  }
}
